
import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IMultiSelectableAsynchronously,
  IMultiSelectableConditionallyAsynchronously,
} from "../../../system/selectors";
import { MultiStringFilterParameter } from "../../../system/filters";
import { ModelEditableMixin } from "../../../system/mixins";
import { DomainRegistry } from "../../../../domain";
import { Profession } from "../../../../domain/user";
import { IProfessionListSelectorDialogCondition } from "../../../profession/dialogs";
import { UserFilterParameter } from "../";

@Component
export default class MultiProfessionListUserFilterableMixin extends Mixins(ModelEditableMixin) {
  data(): any {
    return {
      professions: [] as Profession[],
    };
  }
  professions: Profession[];
  editingSource: UserFilterParameter;

  @Prop({ default: null })
  defaultSelectedProfessionCodes: string[];

  get professionsSource(): Profession[] {
    return this.professions;
  }

  set professionsSource(source: Profession[]) {
    this.professions = source;
    this.professionIds = source
      ? new MultiStringFilterParameter(source.map(s => s.id))
      : new MultiStringFilterParameter();
  }

  get professionIds(): MultiStringFilterParameter {
    return this.editingSource.professionIds;
  }

  set professionIds(source: MultiStringFilterParameter) {
    this.writeProperty(s => s.professionIds = source);
  }

  get professionNameText(): string {
    return this.professions
      ? Enumerable.from(this.professions).select(p => p.name).toArray().join(",")
      : "";
  }

  get multiOrderableProfessionListSelectorDialog(): IMultiSelectableAsynchronously<Profession> & IMultiSelectableConditionallyAsynchronously<Profession, IProfessionListSelectorDialogCondition> {
    return this.$commonDialogs.profession.multiOrderableListSelector;
  }

  async showProfessionSelectorDialog(): Promise<void> {
    const result = await this.multiOrderableProfessionListSelectorDialog.selectOptions(this.professions);
    if (result === undefined) { return; }
    this.professionsSource = result;
  }

  async getDefaultSelectedProfessions(): Promise<Profession[]> {
    if (!this.defaultSelectedProfessionCodes || this.defaultSelectedProfessionCodes.length === 0) { return []; }
    const repository = DomainRegistry.user.getProfessionRepository();
    const professions = await repository.getAllEntities();
    return professions
      ? Enumerable.from(professions).where(p => this.defaultSelectedProfessionCodes.some(d => d === p.id)).select(p => p).toArray()
      : [];
  }
}
